/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Remove_User_TitleInputs */



/**
* | output |
* | --- |
* | "Remove User" |
*
* @param {Team_Manager_Remove_User_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_user_title = /** @type {((inputs?: Team_Manager_Remove_User_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_User_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l’utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover usuário")
	return /** @type {LocalizedString} */ ("Remove User")
});